// extracted by mini-css-extract-plugin
export default {"supplierInfoSimple":"SupplierInfo_supplierInfoSimple__G-ASR"};